module.exports = __webpack_public_path__ + "img/blackLogo.7e11f78e.png";